































































































import '../styles/add-mdresource-modal.css'
import Vue from 'vue'
import Modal from './general/modal/Modal.vue'
import ModalBody from './general/modal/ModalBody.vue'
import { CIcon } from '@coreui/icons-vue'
import { cilX, cilImage } from '@coreui/icons-pro'

import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import { IValidationResult } from '../util/IValidationResult'
import * as mime from 'mime-types'

export default Vue.extend({
  mixins: [validationMixin],
  validations: {
    name: { required },
  },
  name: 'AddMDResourceModal',
  data() {
    return {
      saving: false,
      errors: [],
      imageData: '',

      name: '',
      isDirectory: false,

      exitIcon: cilX,
      imageIcon: cilImage,
      resourceFile: null as any,
    }
  },
  components: { CIcon, Modal, ModalBody },
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    parentId: {
      type: Number,
      required: false,
    },
    type: {
      type: String,
      required: true,
    },
    resource: {
      type: Object,
      required: false,
    },
  },
  watch: {
    resource: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.name = val.name
          this.isDirectory = val.isDirectory
          this.imageData = val.imageData
        }
      },
    },
  },
  updated: function () {
    if (this.$refs.imagefileinput) {
      ;(this.$refs.imagefileinput as HTMLInputElement).onchange = () => {
        const files = (this.$refs.imagefileinput as HTMLInputElement).files
        if (files && files.length > 0) {
          const file = files[0]
          if (file) {
            this.imageData = URL.createObjectURL(file)
          }
        }
      }
    }
  },
  methods: {
    close: function () {
      this.name = ''
      this.imageData = ''
      this.isDirectory = false
      this.resourceFile = null

      this.$v.$reset()
      this.$emit('close')
    },
    add: async function () {
      this.saving = true

      if (this.$v.name.$invalid) {
        this.$v.$touch()
        this.saving = false
        return
      }
      const result = await fetch('/api/mdresources', {
        method: this.type === 'add' ? 'POST' : 'PUT',
        body: JSON.stringify({
          name: this.name,
          isDirectory: this.isDirectory,
          parentId: this.parentId,
          isZipFile:
            !!this.resourceFile &&
            this.resourceFile.name.toLowerCase().endsWith('.zip'),
          id: this.resource?.id,
        }),
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      })
      if (!result.ok) {
        this.errors = (await result.json()).map(
          (x: IValidationResult) => x.errorMessage
        )
      } else {
        const body = await result.json()
        const files = (this.$refs.imagefileinput as HTMLInputElement).files
        if (files && files.length > 0) {
          const file = files[0]
          if (file) {
            const uploadImageUrl = body.uploadImageUrl
            await fetch(uploadImageUrl, {
              method: 'PUT',
              body: file,
              headers: {
                'Content-Type': 'image/png',
                'x-ms-blob-type': 'BlockBlob',
              },
            })
          }
        }

        if (this && this.resourceFile && this.resourceFile.name) {
          const uploadImageUrl = body.uploadResourceLink
          await fetch(uploadImageUrl, {
            method: 'PUT',
            body: this.resourceFile,
            headers: {
              'Content-Type': mime.lookup(this.resourceFile.name) as string,
              'x-ms-blob-type': 'BlockBlob',
              'x-ms-blob-content-disposition': `attachment; filename="${
                this.resourceFile.name as string
              }"`,
            },
          })
        }
      }

      this.saving = false
      this.close()
    },
    selectFile: async function () {
      ;(this.$refs.imagefileinput as HTMLInputElement).click()
    },
  },
  computed: {
    nameErrors(): string[] {
      const errors: string[] = []
      if (this.$v.name.$error) errors.push('Name is required')
      return errors
    },
  },
})
